module.exports = __webpack_public_path__ + "assets/img/loading_failed.4a3a62aa.png";